import Splide from "@splidejs/splide";

if ($(".testimonials-splide").length > 0) {
  const enabled = $(".testimonials-splide .splide__slide").length > 1;
  new Splide(".testimonials-splide", {
    type: enabled ? "loop" : "fade",
    perPage: 1,
    direction: document.documentElement.lang === "ar" ? "rtl" : "ltr",
    arrows: false,
    pagination: enabled,
    gap: "0.2rem",
    autoplay: enabled,
    interval: 3000,
    classes: {
      pagination: "splide__pagination testimonials-paginate",
    },
  }).mount();
}
